import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { XIcon, UserCircleIcon } from 'lucide-react';

interface Props {
  onDismiss: () => void;
}

export function ProfileBanner({ onDismiss }: Props): JSX.Element {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return <></>;

  function dismiss(): void {
    setDismissed(true);
    onDismiss();
  }

  // Mosterdgeel warm-callout per DESIGN.md (was off-brand amber-*). Voice is
  // informeel "je": dit is interne SUPPOHRT-copy (arbeidsmarkt-uitzondering op
  // de "u"-default), besluit Jos 2026-06-22.
  return (
    <div className="flex items-center gap-3 border-b border-mosterdgeel-100 bg-mosterdgeel-10 px-5 py-3">
      <UserCircleIcon size={16} className="shrink-0 text-mosterdgeel-600" />
      <p className="min-w-0 flex-1 text-[13px] text-ink-900">
        Vul je profiel aan zodat collega's je kunnen vinden in het Smoelenboek — voeg een foto,
        specialisaties en regio toe.
      </p>
      <button
        type="button"
        onClick={() => navigate('/profile')}
        className="shrink-0 rounded-lg bg-mosterdgeel-500 px-3 py-1.5 text-[12px] font-semibold text-white transition-colors hover:bg-mosterdgeel-600"
      >
        Profiel aanvullen
      </button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Sluit melding"
        className="shrink-0 rounded-md p-1 text-mosterdgeel-600/70 hover:bg-mosterdgeel-50 hover:text-mosterdgeel-600"
      >
        <XIcon size={14} />
      </button>
    </div>
  );
}
